const Theme = {
  card_background_color: 'white',
  body_background_color: '#00B0E3',

  number_hidden: true,
  token_hidden: true,

  logo_image_url: 'atlantide.png',
  header_full_height: true,

  button_color: '#F2CF63',

  text_font: 'Poppins',
  text_color: 'black',

  title_font: 'Raleway',
  subtitle_font: 'Raleway',

  popup_text_color: 'black',

  button_radius: 10,
  button_border_width: 1
}

export default Theme
